<template>
  <div class="row">
    <div class="col">
       <button class="btn btn-sm btn-primary mb-2" @click="select({ id: 'new' })">Dodaj uporabnika</button>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="table-responsive">
        <table class="table table-stripped table-sm table-hover">
          <thead>
            <tr>
              <th scope="col">Stranka</th>
              <th scope="col">Delavec</th>
              <th scope="col">Ime</th>
              <th scope="col">Vloga</th>
              <th scope="col">Email</th>
            </tr>
          </thead>
          <tbody>
            <tr role="button" v-for="u in users" @click="select(u)">
              <td>{{ u.customerName }}</td>
              <td>{{ u.workerName }}</td>
              <td>{{ u.displayName }}</td>
              <td>{{ u.role }}</td>
              <td>{{ u.email }}</td>
            </tr>
        </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useAuth } from "../composition-api/useAuth"
import { listEntitiesAsync } from "../api"

defineOptions({ name: "Users" })

const router = VueRouter.useRouter()

const { fetchAuthAsync } = useAuth()

const users = ref([])

const select = (cu) => router.push({ name: "UserEdit", params: { userId: cu.id } })

onMounted(async () => (users.value = await listEntitiesAsync(fetchAuthAsync, "Users")))
</script>
